/* WEAVEPLACE Product Card v1.0 — a single delegated controller for all grids and rails */
(()=>{
if(window.__weaveplaceUnifiedCard)return;window.__weaveplaceUnifiedCard=true;
const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
const key='weaveplace-plp-favorites';let saved=[];try{saved=JSON.parse(localStorage.getItem(key)||'[]')}catch{}const favorites=new Set(saved);
let modal,selected='',sourceCard=null,previousFocus=null;

// Auto-close only for successful quick-adds from this shared card, never for manual Header opens.
let autoCloseGeneration=0,autoCloseTimer=null;
function cancelAutoClose(){autoCloseGeneration++;clearTimeout(autoCloseTimer);autoCloseTimer=null}
function scheduleAutoClose(){
  cancelAutoClose();
  // Auto-close after quick add on both desktop and mobile.
  const generation=autoCloseGeneration;
  const drawer=()=>document.querySelector('cart-drawer');
  const began=Date.now();
  const waitForOpen=()=>{
    if(generation!==autoCloseGeneration)return;
    const el=drawer();
    if(el?.classList.contains('active')){
      const attemptClose=()=>{
        if(generation!==autoCloseGeneration)return;
        const current=drawer();
        if(!current?.classList.contains('active'))return;
        // Dawn programmatically traps focus in the drawer. Focus is not proof of interaction.
        // Defer only when a real mouse pointer rests over the drawer panel.
        if(window.matchMedia('(hover: hover) and (pointer: fine)').matches && current.querySelector('.drawer__inner')?.matches(':hover')){
          autoCloseTimer=setTimeout(attemptClose,4000);
          return;
        }
        // Programmatic close must not focus the header cart icon and scroll the page.
        current.activeElement=null;
        current.close?.();
        autoCloseTimer=null;
      };
      autoCloseTimer=setTimeout(attemptClose,4000);
    }else if(Date.now()-began<3000){
      autoCloseTimer=setTimeout(waitForOpen,60);
    }
  };
  waitForOpen();
}
// On touch devices, an intentional interaction with the open cart leaves it open.
// Delegation survives Shopify replacing cart contents after quantity updates.
function cancelOnMobileCartInteraction(event){
  if(!window.matchMedia('(max-width: 1023px)').matches)return;
  const drawer=document.querySelector('cart-drawer');
  if(!drawer?.classList.contains('active'))return;
  const target=event.target;
  if(target instanceof Node && drawer.querySelector('.drawer__inner')?.contains(target)){
    cancelAutoClose();
  }
}
document.addEventListener('pointerdown',cancelOnMobileCartInteraction,true);
document.addEventListener('touchstart',cancelOnMobileCartInteraction,{capture:true,passive:true});
document.addEventListener('keydown',cancelOnMobileCartInteraction,true);
document.addEventListener('scroll',cancelOnMobileCartInteraction,true);
// Clicking the Header cart icon is an explicit manual request to keep the drawer open.
document.addEventListener('click',e=>{if(e.target.closest('#cart-icon-bubble'))cancelAutoClose()},true);
document.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.closest('#cart-icon-bubble'))cancelAutoClose()},true);

function sync(){document.querySelectorAll('[data-wpc-favorite]').forEach(b=>{let c=b.closest('wp-product-card');let active=window.WEAVEPLACEWishlist ? window.WEAVEPLACEWishlist.has(c?.dataset.productId) : favorites.has(c?.dataset.productId);b.setAttribute('aria-pressed',String(active));b.setAttribute('aria-label',active?'Favorilerden çıkar':'Favorilere ekle')})}
function ensureModal(){if(modal)return modal;modal=document.createElement('div');modal.className='wpc-sheet-host';modal.innerHTML='<div class="wpc-sheet__overlay" data-wpc-close></div><div class="wpc-sheet__panel" role="dialog" aria-modal="true" aria-label="Beden seçimi" tabindex="-1"><span class="wpc-sheet__handle"></span><div data-wpc-sheet-content></div></div>';document.body.append(modal);return modal}
let sheetCloseTimer=null;
let sheetOpenFrame1=0,sheetOpenFrame2=0;
function open(card){
  if(sheetCloseTimer){clearTimeout(sheetCloseTimer);sheetCloseTimer=null}
  if(sheetOpenFrame1)cancelAnimationFrame(sheetOpenFrame1);
  if(sheetOpenFrame2)cancelAnimationFrame(sheetOpenFrame2);
  const tpl=card.querySelector('template[data-wpc-sheet]');
  if(!tpl)return;
  sourceCard=card;selected='';previousFocus=document.activeElement;
  const m=ensureModal();
  const panel=m.querySelector('.wpc-sheet__panel');
  m.querySelector('[data-wpc-sheet-content]').replaceChildren(tpl.content.cloneNode(true));
  m.classList.remove('is-open','is-closing');
  m.classList.add('is-preparing');
  document.body.classList.add('wpc-sheet-visible');
  // Establish the hidden/off-screen starting style before toggling is-open.
  // Without this staged frame, the very first opening can skip its transition.
  void panel.offsetHeight;
  sheetOpenFrame1=requestAnimationFrame(()=>{
    sheetOpenFrame1=0;
    if(modal!==m || !m.classList.contains('is-preparing'))return;
    m.classList.remove('is-preparing');
    m.classList.add('is-open');
    panel.focus({preventScroll:true});
  });
}
function close(){
  if(!modal)return;
  if(sheetOpenFrame1)cancelAnimationFrame(sheetOpenFrame1);
  if(sheetOpenFrame2)cancelAnimationFrame(sheetOpenFrame2);
  sheetOpenFrame1=sheetOpenFrame2=0;
  if(modal.classList.contains('is-preparing')){
    modal.classList.remove('is-preparing');
    document.body.classList.remove('wpc-sheet-visible');
    sourceCard=null;selected='';
    return;
  }
  if(!modal.classList.contains('is-open'))return;
  modal.classList.add('is-closing');
  modal.classList.remove('is-open');
  sourceCard=null;selected='';
  // Keep backdrop and panel visible until the exit transition has finished.
  // Moving focus immediately can also cause a mobile page jump.
  const focusTarget=previousFocus;
  previousFocus=null;
  if(sheetCloseTimer)clearTimeout(sheetCloseTimer);
  sheetCloseTimer=setTimeout(()=>{
    sheetCloseTimer=null;
    if(modal?.classList.contains('is-open'))return;
    modal?.classList.remove('is-closing');
    document.body.classList.remove('wpc-sheet-visible');
    if(focusTarget?.isConnected){try{focusTarget.focus({preventScroll:true})}catch{}}
  },400);
}
function imgs(card){try{return JSON.parse(card.querySelector('[data-wpc-images]')?.textContent||'[]')}catch{return []}}
// Swiper 11 gallery, lazy initialized for cards near the viewport.
const wpcSwiperInstances = new WeakMap();
let swiperLoader;
function loadCardSwiper(){
  if(window.Swiper)return Promise.resolve(window.Swiper);
  if(swiperLoader)return swiperLoader;
  const assetBase=new URL('.',document.currentScript?.src || [...document.scripts].find(s=>s.src.includes('weaveplace-product-card.js'))?.src || location.href);
  if(!document.querySelector('[data-wpc-swiper-css]')){
    const style=document.createElement('link');style.rel='stylesheet';style.dataset.wpcSwiperCss='';
    style.href=new URL('weaveplace-swiper-bundle.min.css',assetBase).href;document.head.append(style);
  }
  swiperLoader=new Promise((resolve,reject)=>{
    const script=document.createElement('script');script.src=new URL('weaveplace-swiper-bundle.min.js',assetBase).href;
    script.async=true;script.onload=()=>window.Swiper?resolve(window.Swiper):reject(Error('Swiper unavailable'));
    script.onerror=()=>reject(Error('Unable to load Swiper asset'));
    document.head.append(script);
  });
  return swiperLoader;
}
function imgs(card){try{return JSON.parse(card.querySelector('[data-wpc-images]')?.textContent||'[]')}catch{return []}}
function mountSwiper(card){
  // Home page carousel: the outer rail alone handles horizontal swipes.
  if(card.dataset.cardContext==='carousel')return;
  if(wpcSwiperInstances.has(card))return;
  const link=card.querySelector('.wpc__image-link');
  const images=imgs(card);
  if(!link || images.length<2)return;
  // Product-carousel cards use the outer carousel for touch swipes.
  const inCarousel=card.dataset.cardContext==='carousel';
  const container=document.createElement('div');container.className='wpc__swiper swiper';
  const wrapper=document.createElement('div');wrapper.className='swiper-wrapper';
  // Duplicate two-image sets so Swiper can loop without a reverse jump.
  const galleryImages=images.length===2?[...images,...images]:images;
  galleryImages.forEach((image,i)=>{
    const slide=document.createElement('div');slide.className='swiper-slide';
    const picture=document.createElement('img');picture.className='wpc__swiper-image';
    picture.alt=image.alt||'';picture.src=image.url;
    picture.loading=i<2?'eager':'lazy';picture.decoding='async';picture.draggable=false;
    slide.append(picture);wrapper.append(slide);
  });
  // The carousel sits inside a product link. Native link/image dragging would
  // compete with Swiper's mouse gesture and leave a ghost image held by the cursor.
  link.draggable=false;
  link.querySelectorAll('img').forEach(img=>{img.draggable=false;});
  link.addEventListener('dragstart',event=>event.preventDefault());
  container.append(wrapper);link.append(container);
  // Keep markup and images visible if the library fails to load.
  loadCardSwiper().then(Swiper=>{
    if(!container.isConnected||wpcSwiperInstances.has(card))return;
    const swiper=new Swiper(container,{
      slidesPerView:1,speed:320,loop:true,loopPreventsSliding:false,
      threshold:7,resistanceRatio:0.3,
      // Prevent the browser's native link drag on desktop; retain touch swipes.
      touchStartPreventDefault:true,
      touchMoveStopPropagation:!inCarousel,
      nested:!inCarousel,
      allowTouchMove:!inCarousel,
      simulateTouch:!inCarousel,
      preventClicks:true,preventClicksPropagation:true,
      observer:false,observeParents:false,
      on:{slideChange(s){
          // Swiper sync, but do not overwrite a target set by a rapid arrow click.
          const target=wpcGalleryTargets.get(card);
          const index=target===undefined?s.realIndex%images.length:target;
          card.dataset.imageIndex=String(index);
          card.classList.toggle('is-gallery-active',index>0);
          link.classList.toggle('is-gallery-active',index>0);
        },
          // Manual swipe takes precedence over any previous arrow-click target.
          touchStart(){wpcGalleryTargets.delete(card)},
          sliderFirstMove(){card.dataset.wpcDragging='1'},
          touchEnd(){setTimeout(()=>{delete card.dataset.wpcDragging},160)},
          transitionEnd(){wpcGalleryTargets.delete(card)}}
    });
    wpcSwiperInstances.set(card,swiper);
    const initial=Number(card.dataset.imageIndex||0);
    if(initial>0){if(swiper.params.loop)swiper.slideToLoop(initial,0,false);else swiper.slideTo(initial,0,false);}
    card.classList.add('wpc--swiper-ready');
    // Desktop preview uses the REAL Swiper slide, not a layered duplicate image.
    // The next swipe therefore advances from photo 2 to photo 3.
    const fineHover=window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
    let manuallyNavigated=false;
    const showHoverPhoto=()=>{
      if(!fineHover.matches||manuallyNavigated||swiper.destroyed)return;
      if(Number(card.dataset.imageIndex||0)!==0)return;
      wpcGalleryTargets.delete(card);
      swiper.slideToLoop(1,0,false);
      card.dataset.imageIndex='1';
      card.classList.add('is-gallery-active');
      link.classList.add('is-gallery-active');
    };
    const resetHoverPhoto=()=>{
      if(swiper.destroyed)return;
      manuallyNavigated=false;
      wpcGalleryTargets.delete(card);
      swiper.slideToLoop(0,0,false);
      card.dataset.imageIndex='0';
      card.classList.remove('is-gallery-active');
      link.classList.remove('is-gallery-active');
    };
    card.querySelector('.wpc__media')?.addEventListener('mouseenter',showHoverPhoto);
    card.querySelector('.wpc__media')?.addEventListener('mouseleave',resetHoverPhoto);
    // While the pointer stays on the card, do not restart the hover preview
    // after a drag or arrow navigation.
    container.addEventListener('pointerdown',()=>{manuallyNavigated=true},{passive:true});
    card.querySelectorAll('[data-wpc-next],[data-wpc-prev]').forEach(button=>{
      button.addEventListener('pointerdown',()=>{manuallyNavigated=true},{passive:true});
    });
    if(card.querySelector('.wpc__media')?.matches(':hover'))showHoverPhoto();
  }).catch(error=>console.warn('[WEAVEPLACE Swiper]',error));
}
// One click advances exactly one image, even during quick repeated clicks.
// Track the intended index independently of Swiper transition state.
const wpcGalleryTargets = new WeakMap();
function setImage(card,change){
  if(card.dataset.cardContext==='carousel')return;
  const list=imgs(card);
  if(list.length<2)return;
  const swiper=wpcSwiperInstances.get(card);
  const previous=wpcGalleryTargets.has(card)?wpcGalleryTargets.get(card):Number(card.dataset.imageIndex||0);
  const next=(previous+change+list.length)%list.length;
  wpcGalleryTargets.set(card,next);
  card.dataset.imageIndex=String(next);
  card.classList.toggle('is-gallery-active',next!==0);
  const link=card.querySelector('.wpc__image-link');
  link?.classList.toggle('is-gallery-active',next!==0);
  if(swiper&&!swiper.destroyed){
    // Disable transition-time ignored taps. Instead each tap has a definite target.
    // Use the physical next/previous slide, never slideToLoop(index):
    // slideToLoop may rewind through earlier slides at the wrap boundary.
    if(change>0)swiper.slideNext(320,true);
    else swiper.slidePrev(320,true);
    return;
  }
  // Before async Swiper has mounted, update the plain image and retain the index.
  const first=link?.querySelector('.wpc__image:not(.wpc__image--second)');
  if(first){first.src=list[next].url;first.removeAttribute('srcset');first.alt=list[next].alt||'';}
}

const galleryObserver=('IntersectionObserver'in window)?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{if(entry.isIntersecting){galleryObserver.unobserve(entry.target);mountSwiper(entry.target)}});
},{rootMargin:'450px 0px'}):null;
function observeSwiperCards(context=document){
  context.querySelectorAll?.('wp-product-card.wpc').forEach(card=>{
    if(card.dataset.wpcObserved)return;
    card.dataset.wpcObserved='1';
    if(galleryObserver)galleryObserver.observe(card);else mountSwiper(card);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>observeSwiperCards());else observeSwiperCards();
// Shopify facets/load-more re-render collection cards dynamically.
new MutationObserver(changes=>{
  for(const change of changes)for(const node of change.addedNodes){
    if(node.nodeType!==1)continue;
    if(node.matches?.('wp-product-card.wpc')){observeSwiperCards(node.parentElement||document)}
    else if(node.querySelector?.('wp-product-card.wpc'))observeSwiperCards(node);
  }
}).observe(document.documentElement,{subtree:true,childList:true});
document.addEventListener('click',e=>{const card=e.target.closest?.('wp-product-card.wpc');if(card?.dataset.wpcDragging==='1' && e.target.closest('.wpc__image-link')){e.preventDefault();e.stopImmediatePropagation()}},true);
async function cartAdd(variant,button){if(!variant||button.dataset.loading)return;button.dataset.loading='1';const old=button.textContent;const isDesktopSize=button.matches('.wpc__desktop-sizes [data-wpc-quick-add]');const isIconQuickAdd=button.matches('.wpc__mobile-plus');if(!isDesktopSize){button.disabled=true;if(!isIconQuickAdd)button.textContent='Ekleniyor...'}try{const res=await fetch(`${root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(variant),quantity:1,sections:['cart-icon-bubble','cart-drawer','cart-live-region-text'],sections_url:location.pathname})});const data=await res.json();if(!res.ok)throw Error(data.description||'Ürün sepete eklenemedi');
// Once Shopify confirms success, start the sheet exit while the cart count refreshes.
const sheetExitStart=modal?.classList.contains('is-open')?performance.now():0;
if(sheetExitStart)close();
// Keep the original header link intact: the Cart Drawer attaches its click handler to it.
// Refresh only the count, using cart.js as the authoritative item quantity.
let cart=null;try{const cartResponse=await fetch(`${root}cart.js`,{credentials:'same-origin',cache:'no-store'});if(cartResponse.ok)cart=await cartResponse.json()}catch(err){console.warn('[WEAVEPLACE] Cart count refresh',err)}
const cartLink=document.querySelector('#cart-icon-bubble');
if(cartLink){
  let count=cartLink.querySelector('.cart-count-bubble');
  if(cart&&cart.item_count>0){
    if(!count){count=document.createElement('div');count.className='cart-count-bubble';cartLink.appendChild(count)}
    count.replaceChildren();
    if(cart.item_count<100){const visible=document.createElement('span');visible.setAttribute('aria-hidden','true');visible.textContent=String(cart.item_count);count.appendChild(visible)}
    const sr=document.createElement('span');sr.className='visually-hidden';sr.textContent=`${cart.item_count} ürün`;count.appendChild(sr);
  }else if(cart&&count){count.remove()}
}
// Do not open the cart drawer underneath an exiting size sheet.
// The cart fetch and the 400ms sheet exit run concurrently; wait only for any remaining exit time.
if(sheetExitStart){const remaining=400-(performance.now()-sheetExitStart);if(remaining>0)await new Promise(resolve=>setTimeout(resolve,remaining));}
if(window.publish&&window.PUB_SUB_EVENTS?.cartUpdate)window.publish(window.PUB_SUB_EVENTS.cartUpdate,{source:'weaveplace-unified-card',productVariantId:data.variant_id||data.id,cartData:{...cart,...data,sections:data.sections}});
document.dispatchEvent(new CustomEvent('wp:cart:updated',{detail:{cart,addResult:data}}));
scheduleAutoClose();
if(!isDesktopSize&&!isIconQuickAdd)button.textContent='Eklendi ✓';
}catch(err){console.error('[WEAVEPLACE Product Card]',err);if(!isDesktopSize&&!isIconQuickAdd)button.textContent='Tekrar dene'}finally{if(isDesktopSize){button.classList.remove('is-selected');button.setAttribute('aria-pressed','false')}setTimeout(()=>{if(button.isConnected){if(!isDesktopSize){if(!isIconQuickAdd)button.textContent=old;button.disabled=false}delete button.dataset.loading}},1500)}}
// A touch generates pointerdown AND a later click. Consume both so the tap that
// dismisses the sheet can never activate a product link under the dimmed backdrop.
let suppressSheetClickUntil=0;
const outsideSheetPanel=e=>!e.target.closest?.('.wpc-sheet__panel');
document.addEventListener('pointerdown',e=>{
  if(!modal?.classList.contains('is-open')||!outsideSheetPanel(e))return;
  suppressSheetClickUntil=Date.now()+700;
  e.preventDefault();
  e.stopImmediatePropagation();
  close();
},true);
document.addEventListener('click',e=>{
  if(!modal)return;
  const blocking=modal.classList.contains('is-open')||modal.classList.contains('is-closing')||Date.now()<suppressSheetClickUntil;
  if(!blocking||!outsideSheetPanel(e))return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if(modal.classList.contains('is-open'))close();
},true);
document.addEventListener('click',e=>{
if(modal?.classList.contains('is-open')&&(e.target===modal||e.target===modal.querySelector('.wpc-sheet__overlay')||e.target.closest('[data-wpc-close]'))){e.preventDefault();e.stopPropagation();close();return}
let select=e.target.closest('[data-wpc-select]');if(select&&modal?.contains(select)){if(select.disabled)return;selected=select.dataset.wpcSelect;modal.querySelectorAll('[data-wpc-select]').forEach(b=>b.classList.toggle('is-selected',b===select));let submit=modal.querySelector('[data-wpc-submit]');submit.disabled=!selected;submit.textContent=selected?'Sepete Ekle':'Beden Seç';return}
let submit=e.target.closest('[data-wpc-submit]');if(submit&&selected){cartAdd(selected,submit);return}
let card=e.target.closest('wp-product-card');if(!card)return;
let wish=e.target.closest('[data-wpc-favorite]');if(wish){e.preventDefault();e.stopPropagation();let id=card.dataset.productId;favorites.has(id)?favorites.delete(id):favorites.add(id);try{localStorage.setItem(key,JSON.stringify([...favorites]))}catch{}sync();return}
let openBtn=e.target.closest('[data-wpc-open]');if(openBtn){e.preventDefault();e.stopPropagation();if(openBtn.dataset.wpcDirectAdd){cartAdd(openBtn.dataset.wpcDirectAdd,openBtn)}else{open(card)}return}
let quick=e.target.closest('[data-wpc-quick-add]');if(quick){e.preventDefault();if(quick.disabled||quick.dataset.loading)return;card.querySelectorAll('.wpc__desktop-sizes [data-wpc-quick-add]').forEach(b=>{const active=b===quick;b.classList.toggle('is-selected',active);b.setAttribute('aria-pressed',String(active))});cartAdd(quick.dataset.wpcQuickAdd,quick);return}
let dir=e.target.closest('[data-wpc-next]')?1:e.target.closest('[data-wpc-prev]')?-1:0;if(dir){e.preventDefault();setImage(card,dir);return}
});
document.addEventListener('keydown',e=>{if(!modal?.classList.contains('is-open'))return;if(e.key==='Escape'){close();return}if(e.key==='Tab'){const els=[...modal.querySelectorAll('button:not([disabled]),a[href]')];let i=els.indexOf(document.activeElement);if(!els.length)return;if(e.shiftKey&&i===0){e.preventDefault();els.at(-1).focus()}else if(!e.shiftKey&&i===els.length-1){e.preventDefault();els[0].focus()}}});
// Stable color preview: never replace the native card/gallery image src or srcset.
// Reuse decoded previews and cancel outdated requests when hovering quickly.
const wpcColorImageCache=new Map();
const wpcFinePointer=window.matchMedia('(hover: hover) and (pointer: fine)');
function wpcPreloadColor(url){
  if(!wpcColorImageCache.has(url)){
    const img=new Image();
    const promise=new Promise(resolve=>{
      img.onload=()=>{if(img.decode){img.decode().catch(()=>{}).then(()=>resolve(true));}else resolve(true)};
      img.onerror=()=>resolve(false);
    });
    img.src=url;
    wpcColorImageCache.set(url,promise);
  }
  return wpcColorImageCache.get(url);
}
function wpcColorLayer(card){
  let layer=card.querySelector('[data-wpc-color-preview]');
  if(layer)return layer;
  const media=card.querySelector('.wpc__media');
  if(!media)return null;
  layer=document.createElement('img');
  layer.className='wpc__color-preview';
  layer.dataset.wpcColorPreview='';
  layer.alt='';
  layer.setAttribute('aria-hidden','true');
  layer.decoding='async';
  media.appendChild(layer);
  return layer;
}
function wpcHideColor(card){
  if(!card)return;
  card._wpcColorRequest=(card._wpcColorRequest||0)+1;
  const layer=card.querySelector('[data-wpc-color-preview]');
  if(layer)layer.classList.remove('is-visible');
}
function wpcShowColor(swatch){
  if(!wpcFinePointer.matches)return;
  const card=swatch.closest('wp-product-card');
  const url=swatch.dataset.wpcSwatchImage;
  if(!card||!url)return;
  const token=card._wpcColorRequest=(card._wpcColorRequest||0)+1;
  const layer=wpcColorLayer(card);
  if(!layer)return;
  if(swatch.matches('.is-active,[aria-current="page"]')){
    layer.classList.remove('is-visible');
    return;
  }
  // Keep the old preview until the new image has decoded. No blank frames.
  wpcPreloadColor(url).then(ok=>{
    if(!ok||token!==card._wpcColorRequest||!swatch.matches(':hover'))return;
    if(layer.getAttribute('src')!==url)layer.src=url;
    layer.classList.add('is-visible');
  });
}
document.addEventListener('pointerover',e=>{
  const sw=e.target.closest('[data-wpc-swatch-image]');
  if(!sw||sw.contains(e.relatedTarget))return;
  wpcShowColor(sw);
});
document.addEventListener('pointerout',e=>{
  const sw=e.target.closest('[data-wpc-swatch-image]');
  if(!sw||sw.contains(e.relatedTarget))return;
  const card=sw.closest('wp-product-card');
  const next=e.relatedTarget instanceof Element?e.relatedTarget.closest('[data-wpc-swatch-image]'):null;
  if(next&&next.closest('wp-product-card')===card){wpcShowColor(next);return;}
  wpcHideColor(card);
});
document.addEventListener('pointerleave',e=>{if(e.target.matches?.('wp-product-card'))wpcHideColor(e.target)},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();
new MutationObserver(m=>{if(m.some(x=>x.addedNodes.length))sync()}).observe(document.documentElement,{childList:true,subtree:true});
})();
